import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import SweetAlert2 from 'sweetalert2';

import { NSMessages } from '@ruby/configs/messages.constants';
import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';
import { IIPAuthorizations } from '@ruby/modules/customer-select/models/ip-authorization.interface';
import { ITrackMovePayload } from '@ruby/modules/track-move/models/track-move.interface';
import { fromTrackMove, TrackMoveActions, TrackMoveSelectors } from '@ruby/modules/track-move/store';
import { EColors } from '@ruby/shared/enums/colors.enums';
import { ITrack } from '@ruby/shared/models/inventory-management/inventory-header.interface';

@Component({
  selector: 'ng-track-move-container',
  templateUrl: './track-move.container.html',
  styleUrls: ['./track-move.container.scss']
})
export class TrackMoveContainerComponent implements OnDestroy {
  customerSelected!: ICustomer;
  store$: Observable<{ trackMoveState: fromTrackMove.State; customerSelected?: ICustomer; userRacf?: string; authorizations?: IIPAuthorizations }>;

  // @TODO FIX THIS
  /* istanbul ignore next */
  constructor(private store: Store<fromTrackMove.State>, private router: Router) {
    this.store$ = this.store.select(TrackMoveSelectors.selectTrackMoveWithAuth).pipe(
      tap((st: { customerSelected?: ICustomer; userRacf?: string; trackMoveState: fromTrackMove.State; authorizations?: IIPAuthorizations }) => {
        if (st.customerSelected &&
          (!this.customerSelected || (this.customerSelected && this.customerSelected.customerIdentifier !== st.customerSelected.customerIdentifier)) &&
          st.userRacf &&
          st.authorizations
        ) {
          this.customerSelected = st.customerSelected;
          if (st.authorizations.canDoTrackMoves) {
            this.store.dispatch(TrackMoveActions.loadTracks({
              data: {
                classCode: this.customerSelected.locations[0].classCode,
                stationCode: this.customerSelected.locations[0].stationCode
              } as ITrackMovePayload
            }));
          } else {
            //@TODO Fix this
            /* istanbul ignore next */
            SweetAlert2.fire({
              title: 'Alert',
              text: NSMessages.notAuthorized,
              icon: 'error',
              heightAuto: false,
              confirmButtonColor: EColors.GOLD,
              willClose: () => { this.router.navigate(['./home/dashboard']); }
            });
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.store.dispatch(TrackMoveActions.setToTrack({ data: undefined }));
    this.store.dispatch(TrackMoveActions.setFromTrack({ data: undefined }));
    this.store.dispatch(
      TrackMoveActions.unlockTrack({
        data: {
          classCode: this.customerSelected.locations[0].classCode,
          stationCode: this.customerSelected.locations[0].stationCode
        } as ITrackMovePayload
      })
    );
  }

  /**
   * Dispatch Selected To Track
   *
   * @summary Dispatches selected track
   * @param $track: ITrack
   * @returns void
   */
  dispatchSelectedToTracK($track: ITrack | undefined): void {
    this.store.dispatch(TrackMoveActions.setToTrack({ data: $track }));
    this.store.dispatch(TrackMoveActions.setToTrackEquipments({ data: [] }));
    if ($track) {
      this.store.dispatch(TrackMoveActions.loadToTrackDetails({
        data: {
          classCode: this.customerSelected.locations[0].classCode,
          stationCode: this.customerSelected.locations[0].stationCode,
          trackID: $track.id,
          trackName: $track.name,
          mainTrack: $track.mainTrack
        } as ITrackMovePayload
      }));
    }
  }

  /**
   * Dispatch Move Track
   *
   * @summary Dispatches selected inventory
   * @param $payload: ITrackMovePayload
   * @returns void
   */
  dispatchMoveTrack($payload: ITrackMovePayload): void {
    $payload.classCode = this.customerSelected.locations[0].classCode;
    $payload.stationCode = this.customerSelected.locations[0].stationCode;
    this.store.dispatch(TrackMoveActions.moveTrack({ data: $payload }));
  }
}
